import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://static.readdy.ai/image/7d3e6a33ff3ec6867c6d17500d87965d/424c50f36ec13e40d68d42093a09aee8.png" 
              alt="Gang Nam Style Karaoke Logo" 
              className="h-12 w-auto"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              Gang Nam Style Karaoke
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-all hover:scale-105 ${
                isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('menu')}
              className={`text-base font-medium transition-all hover:scale-105 ${
                isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
              }`}
            >
              Menu
            </button>
            <button
              onClick={() => scrollToSection('live-karaoke')}
              className={`text-base font-medium transition-all hover:scale-105 ${
                isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
              }`}
            >
              Live Karaoke
            </button>
            <button
              onClick={() => scrollToSection('hours-location')}
              className={`text-base font-medium transition-all hover:scale-105 ${
                isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
              }`}
            >
              Hours &amp; Location
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-all hover:scale-105 ${
                isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
              }`}
            >
              Contact
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-pink-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-pink-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Book Now
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4">
            <div className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('about')}
                className={`text-base font-medium text-left py-2 transition-colors ${
                  isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
                }`}
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('menu')}
                className={`text-base font-medium text-left py-2 transition-colors ${
                  isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
                }`}
              >
                Menu
              </button>
              <button
                onClick={() => scrollToSection('live-karaoke')}
                className={`text-base font-medium text-left py-2 transition-colors ${
                  isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
                }`}
              >
                Live Karaoke
              </button>
              <button
                onClick={() => scrollToSection('hours-location')}
                className={`text-base font-medium text-left py-2 transition-colors ${
                  isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
                }`}
              >
                Hours &amp; Location
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className={`text-base font-medium text-left py-2 transition-colors ${
                  isScrolled ? 'text-gray-700 hover:text-pink-600' : 'text-white hover:text-pink-400'
                }`}
              >
                Contact
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-pink-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-pink-700 transition-all shadow-lg whitespace-nowrap text-center mt-2"
              >
                Book Now
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
